// extracted by mini-css-extract-plugin
module.exports = {"tools":"AdminTools_tools__0gdGD","tools-button":"AdminTools_tools-button__okdKc"};